import * as React from 'react';
import classnames from 'classnames';
import { GatsbyLinkProps } from 'gatsby';
import ExternalLink, { ExternalLinkProps } from 'core/components/ExternalLink';
import ConditionalLink, {
    ConditionalLinkProps,
} from 'core/components/ConditionalLink';
import * as styles from './CallToAction.module.scss';

export type CallToActionVariant = 'contained' | 'outlined' | 'text' | 'primary';
export type CallToActionSize = 'small' | 'medium';

type AnchorProps = React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
>;

type ButtonProps = React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
>;

export type CallToActionProps = (
    | (ButtonProps & { Component?: 'button' })
    | (AnchorProps & { Component?: 'a' })
    | (ExternalLinkProps & { Component?: typeof ExternalLink })
    | (ConditionalLinkProps & { Component?: typeof ConditionalLink })
    | (GatsbyLinkProps<unknown> & { Component?: React.ElementType })
) & {
    variant: CallToActionVariant;
    size: CallToActionSize;
    disabled?: boolean;
};

export default function CallToAction({
    Component = 'button',
    className,
    variant,
    size,
    ...props
}: CallToActionProps) {
    return (
        <Component
            className={classnames(className, styles.root, {
                [styles.contained]: variant === 'contained',
                [styles.outlined]: variant === 'outlined',
                [styles.text]: variant === 'text',
                [styles.primary]: variant === 'primary',
                [styles.small]: size === 'small',
                [styles.medium]: size === 'medium',
            })}
            {...props}
        />
    );
}

CallToAction.defaultProps = {
    Component: 'button',
    variant: 'contained',
    size: 'medium',
};
